import './bml-contact-form.scss';
const DEFAULT_HEADING = 'Станьте партнером';
const DEFAULT_BUTTON_TEXT = 'Відправити заявку';

function buildTemplate(heading, buttonText) {
    return `
<section class="contact-us fade-up">
    <div class="contact-circles-container" data-animate-circles>
        <div class="contact-circle contact-circle-large"></div>
        <div class="contact-circle contact-circle-medium"></div>
        <div class="contact-circle contact-circle-small"></div>
    </div>

    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-6" data-animate-child>
                <p>${heading}</p>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="contact-container" data-animate-child>
                    <form class="contact-form">
                        <div class="input-row">
                            <div class="input-wrapper" data-animate-child>
                                <div class="input-inner">
                                    <input type="text" class="input-field" id="name" placeholder="">
                                    <label for="name" class="floating-label">Ім'я</label>
                                </div>
                            </div>
                            <div class="input-wrapper wrapper-phone" data-animate-child>
                                <div class="input-inner">
                                    <input type="tel" id="phone" class="input-field" placeholder="">
                                    <label for="phone" class="floating-label">Телефон</label>
                                </div>
                            </div>
                        </div>
                        <div class="input-wrapper" data-animate-child>
                            <div class="input-inner">
                                <input type="text" class="input-field" id="clinic" placeholder="">
                                <label for="clinic" class="floating-label">Назва вашого медичного закладу</label>
                            </div>
                        </div>
                        <div class="input-wrapper" data-animate-child>
                            <div class="input-inner">
                                <textarea class="input-field text-area" id="message" placeholder=""></textarea>
                                <label for="message" class="floating-label">Повідомлення</label>
                            </div>
                        </div>
                        <div class="input-wrapper checkbox-wrapper" data-animate-child>
                            <label class="checkbox-label">
                                <input type="checkbox" class="checkbox-input">
                                <span class="checkbox-text">Я прочитав, розумію та погоджуюсь з <a href="/privacy-policy" target="_blank">Політикою конфіденційності</a> та <a href="/personal-data-policy" target="_blank">Політикою обробки персональних даних</a></span>
                            </label>
                        </div>
                        <div class="input-wrapper" data-animate-child>
                            <button type="submit" class="submit-btn">${buttonText}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>
`;
}

class BmlContactForm extends HTMLElement {
    connectedCallback() {
        if (!this.innerHTML.trim()) {
            const heading = this.getAttribute('heading') || DEFAULT_HEADING;
            const buttonText = this.getAttribute('button-text') || DEFAULT_BUTTON_TEXT;
            this.innerHTML = buildTemplate(heading, buttonText);
        }
        const sectionId = this.getAttribute('section-id');
        if (sectionId) {
            const section = this.querySelector('section');
            if (section) section.id = sectionId;
        }
    }
}

customElements.define('bml-contact-form', BmlContactForm);
